import { atom } from 'jotai';
import { atomWithRefresh } from 'jotai/utils';
import { Optional } from '../../../Common/interfaces';

const regex = /\/modules\/(\d+)\/details(?:\/([^/]+)(?:\/([^/]+))?)?/;

function parseURL(url: string): {
    moduleID: Optional<number>;
    exerciseCode: Optional<string>;
    pageNumber: Optional<number>;
} {
    const [_, moduleID, exerciseCode, pageNumber] = url.match(regex);
    return {
        moduleID: safeParse(moduleID),
        exerciseCode,
        pageNumber: safeParse(pageNumber),
    };
}

function safeParse(input: Optional<string>): Optional<number> {
    if (input == null) return null;
    const parsed = +input;
    return Number.isNaN(parsed) ? null : parsed;
}

export const locationAtom = atomWithRefresh(() => location.href);
locationAtom.onMount = (set) => {
    function handler(event: PopStateEvent) {
        set();
    }
    window.addEventListener('popstate', handler);
    return () => {
        window.removeEventListener('popstate', handler);
    };
};
const urlParams = atom((get) => parseURL(get(locationAtom)));

export const requestedModuleIDAtom = atom((get) => get(urlParams).moduleID);
export const requestedExerciseCodeAtom = atom(
    (get) => get(urlParams).exerciseCode,
);
export const requestedPageNumberAtom = atom((get) => get(urlParams).pageNumber);
